<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Rates</div>
        <div>
          <bread-crumb :bread-crumbs="['Rates']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-tabs
          color="primary"
          v-model="tabSeleted"
          grow
          slider-color="primary"
        >
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="'#' + item.key"
            :disabled="item.disabled"
            color="white"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabSeleted">
          <!-- <v-tab-item id="country"> <countryRates /></v-tab-item> -->
          <!-- <v-tab-item id="partner"><partnerRates /> </v-tab-item> -->
          <v-tab-item id="dashboard"><dashboardRatesVue /> </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import countryRates from "./RatesTabs/countryRates.vue";
import dashboardRatesVue from "./RatesTabs/dashboardRates.vue";
// import partnerRates from "./RatesTabs/partnerRates.vue";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
export default {
  name: "Rates",
  components: {
    Loading,
    // countryRates,
    dashboardRatesVue,
    // partnerRates,
    BreadCrumb,
  },
  mixins: [alerts],
  data() {
    return {
      currentItem: "",
      loader: false,
      tabSeleted: 0,
      items: [
        // { label: "Country Rates", key: "country" },

        // {
        //   label: "Partner Rates",
        //   key: "partner",
        // },
        {
          label: "Dashboard Rates",
          key: "dashboard",
        },
      ],
    };
  },

  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
